export default __webpack_public_path__ + "_/_/components/src/components/error-modal/triangle-warning.webp";